import { SVGAttributes } from "react";

function RemoveDoneIcon(props: SVGAttributes<HTMLOrSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path fill="none" d="M0 0h24v24H0zm0 0h24v24H0V0z" />
      <path d="m1.8 12 5.6 5.6L6 19 .4 13.4 1.8 12zm.4-7.8L13 15l-1.3 1.3L7.4 12 6 13.4l5.6 5.6 2.7-2.7 4.9 4.9 1.4-1.4-17-17-1.4 1.4zm15 9.3L23.5 7l-1.4-1.4-6.5 6.5 1.4 1.4zM18 7l-1.4-1.4-3.7 3.7 1.4 1.4L18 7z" />
    </svg>
  );
}

export default RemoveDoneIcon;
